export default __webpack_public_path__ + "static/media/moltenflesh.5d3d9f7c.png";